import React, { useEffect, useState } from 'react'
import { Col, Row, FormGroup, Alert, Input } from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from 'views/shared/useFormUtils'
import PropTypes from 'prop-types'
import { isNotNumericDecimal } from 'context/Utilities'

const BSWholeWheatBagelsPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    Size: item.Size,
  })
  const methods = useFormContext()
  const { onChangeReviewer, asterisk } = useFormUtils()
  useEffect(() => {
    if (item !== null) {
      const { Size } = item
      setPackaging({
        Size,
      })
    }
    // eslint-disable-next-line
    }, [item])

  return (
    <>
      <Row>
        <Col xs={6}>
          <FormGroup>
            <p>
              <strong>Size {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="Size"
              type="number"
              step="0.01"
              placeholder={'12 - 48 ounces'}
              defaultValue={packaging.Size}
              onKeyDown={e => {
                if (isNotNumericDecimal(e.key)) {
                  e.preventDefault()
                }
              }}
              control={methods.control}
              rules={{
                maxLength: {
                  value: 5,
                  message: '⚠ Size exceeds 5 characters.',
                },
                min: {
                  value: 12,
                  message: '⚠ Size is below the required 12 ounce minimum.',
                },
                max: {
                  value: 48,
                  message: '⚠ Size exceeds the 48 ounces allowed.',
                },
                required: {
                  value: true,
                  message: '⚠ Please enter product size.',
                },
                pattern: {
                  value: /^\d+(\.\d{1,2})?$/,
                  message: '⚠ Maximum two decimal places allowed.',
                },
              }}
              onChange={([event]) => {
                onChangeReviewer(item, event)
                return event
              }}
              disabled={isDisabled}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="Size"
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        </Col>
      </Row>
    </>
  )
}

BSWholeWheatBagelsPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default BSWholeWheatBagelsPackageReview
